import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { importsRoutes } from './routes'
import { importsPath } from './index'
import { toRelativeRoute, wrapRoutesWithRouter } from '../shared/utils/routerPaths'

const wrappedImportsRoutes = wrapRoutesWithRouter(importsRoutes)
import { ImportsLayout } from './ImportsLayout'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { TaskProvider } from '@/modules/shared/context/TaskContext'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'

const ImportsModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
      <TaskProvider>
          <AppLayoutDahboardWithNav>
            <ErrorBoundary
              fallback={(e) => (
                <ErrorFallback error={e.error} onRetry={e.reset} />
              )}
            >
                <PermissionGuard companyId={companyId} {...moduleAccess.imports}>
                <ImportsLayout companyId={companyId!}>
                  <Routes>
                    {wrappedImportsRoutes.map((route) => (
                        <Route
                          key={route.path}
                          path={`${toRelativeRoute(route.path, importsPath)}/*`}
                          element={<route.Component />}
                        />
                      ))}

                    {/* fallback */}
                    <Route
                      path="*"
                      element={<div data-test-id="imports-module-router-fallback"></div>}
                    />
                  </Routes>
                </ImportsLayout>
                </PermissionGuard>
            </ErrorBoundary>
          </AppLayoutDahboardWithNav>
      </TaskProvider>
    </ErrorBoundary>
  )
}

export const ImportsModule = ImportsModuleImpl
